if (!customElements.get('quick-order-page')) {
  const nativeSubmitButtons = new Set();
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    nativeSubmitButtons.forEach((button) => { button.disabled = false; });
    nativeSubmitButtons.clear();
  });

  customElements.define('quick-order-page', class QuickOrderPage extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', (event) => {
        if (event.target.name !== 'id') return;
        const form = event.target.closest('form');
        const variant = event.target.selectedOptions[0];
        const quantity = form.querySelector('[name="quantity"]');
        quantity.min = variant.dataset.min;
        quantity.step = variant.dataset.step;
        if (variant.dataset.max) quantity.max = variant.dataset.max;
        else quantity.removeAttribute('max');
        quantity.value = variant.dataset.min;
        form.querySelector('.quick-order-page__price').textContent = variant.dataset.price;
        form.querySelector('.quick-order-page__status').textContent = '';
      });
      this.addEventListener('submit', this.addItem.bind(this));
    }

    async addItem(event) {
      event.preventDefault();
      const form = event.target;
      const button = form.querySelector('[type="submit"]');
      if (button.disabled) return;

      const variantInput = form.querySelector('[name="id"]');
      const variant = variantInput.selectedOptions?.[0] || variantInput;
      const quantityInput = form.querySelector('[name="quantity"]');
      const quantity = Number(quantityInput.value);
      const min = Number(variant.dataset.min);
      const step = Number(variant.dataset.step);
      const max = variant.dataset.max ? Number(variant.dataset.max) : Infinity;
      if (!Number.isInteger(quantity) || quantity < min || quantity > max || quantity % step !== 0 || !quantityInput.checkValidity()) {
        quantityInput.reportValidity();
        return;
      }

      button.disabled = true;
      const status = form.querySelector('.quick-order-page__status');
      status.textContent = '';
      const id = Number(variant.value);
      const payload = { items: [{ id, quantity }] };
      let cart;
      let drawerUsable = false;
      try {
        cart = document.querySelector('cart-drawer');
        drawerUsable = cart && typeof cart.getSectionsToRender === 'function' &&
          typeof cart.setActiveElement === 'function' && typeof cart.renderContents === 'function';
        if (cart && !drawerUsable) throw new Error('Cart drawer unavailable');
        if (drawerUsable) {
          payload.sections = cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
          cart.setActiveElement(button);
        }
      } catch (error) {
        nativeSubmitButtons.add(button);
        HTMLFormElement.prototype.submit.call(form);
        return;
      }

      try {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.body = JSON.stringify(payload);
        const response = await fetch(window.routes.cart_add_url, config);
        let data;
        try {
          data = await response.json();
        } catch (error) {
          if (!response.ok && !response.redirected) {
            status.textContent = this.dataset.error;
            return;
          }
          status.textContent = this.dataset.checkCart;
          if (drawerUsable) {
            try {
              const sections = await fetch(`${window.routes.cart_url}?sections=${payload.sections.join(',')}`);
              if (!sections.ok) throw new Error('Cart sections unavailable');
              cart.renderContents({ sections: await sections.json() });
              cart.classList.remove('is-empty');
            } catch (error) {
              window.location.assign(window.routes.cart_url);
            }
          } else {
            window.location.assign(window.routes.cart_url);
          }
          return;
        }
        if (!response.ok || data.status) {
          status.textContent = response.status === 422 ? data.description || this.dataset.error : this.dataset.error;
          return;
        }

        status.textContent = this.dataset.added;
        if (drawerUsable) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-order-page', productVariantId: id, cartData: data });
          cart.renderContents(data);
          cart.classList.remove('is-empty');
        } else {
          window.location.assign(window.routes.cart_url);
        }
      } catch (error) {
        if (status.textContent !== this.dataset.added) status.textContent = this.dataset.error;
      } finally {
        button.disabled = false;
      }
    }
  });
}
